import type { JSX } from "react";

import { Field, FieldError, FieldLabel } from "../field";
import { InputGroup, InputGroupInput } from "../input-group";
import { cn } from "../lib/utils";
import { useFieldContext } from "./form-context";

type TextFieldProps = React.ComponentProps<"input"> & {
	label?: string | JSX.Element;
	required?: boolean;
	placeholder?: string;
	autoComplete?: string;
	type?: string;
};

export function TextField({
	className,
	label,
	required,
	placeholder,
	autoComplete,
	type = "text",
	...props
}: TextFieldProps) {
	const field = useFieldContext<string>();

	const isInvalid = field.store.state.meta.isTouched && !field.store.state.meta.isValid;

	return (
		<Field data-invalid={isInvalid}>
			{label && (
				<FieldLabel htmlFor={field.name}>
					{label}
					{required ? " *" : ""}
				</FieldLabel>
			)}
			<InputGroup>
				<InputGroupInput
					aria-invalid={isInvalid}
					autoComplete={autoComplete}
					className={cn(className)}
					data-slot="input-group-control"
					id={field.name}
					name={field.name}
					onBlur={field.handleBlur}
					onChange={(e) => field.handleChange(e.target.value)}
					placeholder={placeholder}
					type={type}
					value={field.store.state.value}
					{...props}
				/>
			</InputGroup>
			{isInvalid && <FieldError errors={field.store.state.meta.errors} />}
		</Field>
	);
}
